import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime } from 'rxjs';

@Injectable()
export class PageTitleService {
  private readonly _visible$ = new BehaviorSubject<boolean>(false);
  private readonly _title$ = new BehaviorSubject<string>('');
  private readonly _back$ = new BehaviorSubject<string>(null);

  readonly visible$ = this._visible$.pipe(debounceTime(100));
  readonly title$ = this._title$.asObservable();
  readonly backLink$ = this._back$.asObservable();

  setTitle(value: string): void {
    this._title$.next(value);
  }

  setBackLink(link: string): void {
    this._back$.next(link);
  }

  updateVisible(value: boolean): void {
    this._visible$.next(value);
  }
}
